import { render, staticRenderFns } from "./searchScreen.vue?vue&type=template&id=638d91d2"
import script from "./searchScreen.vue?vue&type=script&lang=js"
export * from "./searchScreen.vue?vue&type=script&lang=js"
import style0 from "./searchScreen.vue?vue&type=style&index=0&id=638d91d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports